import { useEffect, useState } from 'react'

/**
 * Whole seconds remaining until `iso` (a timestamp string), re-computed every
 * second. Returns null when `iso` is null or already in the past — so callers can
 * treat "null" as "not counting down". Used for the outbound-automation auto-pause
 * "resuming in Ns" countdown.
 *
 * The remaining time is derived inside the effect (not during render) so we never
 * call `Date.now()` while rendering.
 */
export function useSecondsUntil(iso: string | null): number | null {
  const [secs, setSecs] = useState<number | null>(null)
  useEffect(() => {
    if (!iso) {
      setSecs(null)
      return
    }
    const compute = () => {
      const remaining = Math.ceil((new Date(iso).getTime() - Date.now()) / 1000)
      setSecs(remaining > 0 ? remaining : null)
    }
    compute()
    const timer = setInterval(compute, 1000)
    return () => clearInterval(timer)
  }, [iso])
  return secs
}
